// eslint-disable-next-line no-redeclare

import { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/browser";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ErrorBoundary } from "react-error-boundary";
import { CssBaseline, StyledEngineProvider, ThemeProvider } from "@mui/material";

import "./index.scss";
import "react-table-6/react-table.css";

import { SuspenseSpinner, ErrorFallback } from "./tctt.js";
import theme from "./theme.js";
import Header from "./components/Header.js";
import DifferentAccess from "./components/DifferentAccess.js";
import GuestOnly from "./components/GuestOnly.js";
import Snackbar from "./components/Snackbar.js";
import NotFound from "./screens/NotFound.js";
import SignIn from "./screens/SignIn.js";
import Auth from "./screens/Auth.js";
import HomeAuthenticated from "./screens/HomeAuthenticated.js";
import HomeUnauthenticated from "./screens/HomeUnauthenticated.js";

const {
	NODE_ENV,
	REACT_APP_SENTRY_DSN,
	REACT_APP_SENTRY_ENVIRONMENT,
} = process.env;

Sentry.init({
	dsn: REACT_APP_SENTRY_DSN,
	environment: REACT_APP_SENTRY_ENVIRONMENT,
	ignoreErrors: [
		"ResizeObserver loop limit exceeded",
		"Non-Error promise rejection captured",
	],
	enabled: NODE_ENV === "production",
});

const App = () => (
	<StyledEngineProvider injectFirst>
		<CssBaseline />
		<ThemeProvider theme={theme}>
			<ErrorBoundary FallbackComponent={ErrorFallback}>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<Header />
					<main style={{ position: "relative", zIndex: 0, height: `calc(100vh - 100px)` }}>
						<Routes>
							<Route index element={<DifferentAccess AuthenticatedComponent={HomeAuthenticated} UnauthenticatedComponent={HomeUnauthenticated} />} />
							<Route path="auth" element={<GuestOnly c={<Auth />} />} />
							<Route path="sign-in" element={<GuestOnly c={<SignIn />} />} />
							<Route path="*" element={<NotFound />} />
						</Routes>
					</main>
					<Snackbar />
				</LocalizationProvider>
			</ErrorBoundary>
		</ThemeProvider>
	</StyledEngineProvider>
);

const root = ReactDOM.createRoot(document.querySelector("#root"));
root.render(
	<Suspense fallback={<SuspenseSpinner />}>
		<Router>
			<App />
		</Router>
	</Suspense>,
);
